export enum UserRole {
  CAPTAIN,
  MEMBER,
  PERSONAL,
  ANON,
}
